import React, { useState, memo, useEffect } from "react"

import SwitchComponent from "../../../../atoms/Switch"
import Radio from "../../../../atoms/Radio"
import styles from "./index.module.scss"
import intl from "react-intl-universal"

export const WestgardRulerItemComponent = ({
  cruler,
  rule,
  fnHandleChangeRuler,
  id,
  bstatus,
  isSigma = false,
}) => {
  const [bSwitchActive, setbSwitchActive] = useState(bstatus)
  const [bAlert, setBAlert] = useState(rule.eqpanltwgr_eaction === "A")
  const [bRejection, setBRejection] = useState(rule.eqpanltwgr_eaction === "R")
  const [bDisabled, setBDisabled] = useState(!bSwitchActive)

  useEffect(() => {
    setbSwitchActive(bstatus)
    setBAlert(rule?.eqpanltwgr_eaction === "A")
    setBRejection(rule?.eqpanltwgr_eaction === "R")
  }, [rule, bstatus])

  return (
    <div className={styles.containerRuler}>
      <SwitchComponent
        cSizeFont="3rem !important"
        bg="transparent"
        width="60px"
        border="none"
        disabled={isSigma}
        bRulesWestgard
        onClick={() => {
          setBDisabled(!bDisabled)
          setbSwitchActive((oldState) => !oldState)
          setTimeout(() => {
            fnHandleChangeRuler({
              eqpanltwgr_wgrdr_nid: id,
              eqpanltwgr_eaction: bAlert && !bRejection ? "A" : "R",
              eqpanltwgr_bstatus: !bSwitchActive,
            })
          }, 100)
        }}
        value={bSwitchActive}
      />
      <p className={styles.cruler}>{cruler}</p>
      <div
        className={`${styles.containerRadioLeft} ${
          bDisabled || isSigma ? styles.opacity : ""
        }`}
      >
        <Radio
          label={intl.get("ciq.alert_up")}
          disabled={bDisabled || isSigma}
          onClick={() => {
            setBAlert(true)
            setBRejection(false)
            fnHandleChangeRuler({
              eqpanltwgr_wgrdr_nid: id,
              // eslint-disable-next-line no-constant-condition
              eqpanltwgr_eaction: true ? "A" : "R",
              eqpanltwgr_bstatus: bSwitchActive,
            })
          }}
          checked={bAlert}
        />
      </div>
      <div
        className={`${styles.containerRadioRight} ${
          bDisabled || isSigma ? styles.opacity : ""
        }`}
      >
        <Radio
          label={intl.get("ciq.rejection_up")}
          disabled={bDisabled || isSigma}
          onClick={() => {
            setBRejection(true)
            setBAlert(false)
            fnHandleChangeRuler({
              eqpanltwgr_wgrdr_nid: id,
              // eslint-disable-next-line no-constant-condition
              eqpanltwgr_eaction: false ? "A" : "R",
              eqpanltwgr_bstatus: bSwitchActive,
            })
          }}
          checked={bRejection}
        />
      </div>
    </div>
  )
}

export const WestgardRulerItem = memo(WestgardRulerItemComponent)
